<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" :tbody-tr-class="rowClass">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(consultTarget)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.consultTarget)">{{ data.item.consultTarget }}</div>
      </template>

      <template v-slot:cell(consultTargetOpinion)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.consultTargetOpinion)">{{ data.item.consultTargetOpinion }}</div>
      </template>

      <template v-slot:cell(attachList)="data">
        <div style="color: #4caedc" v-for="(file,index) in data.item.attachList" @click="$viewAttach(file)">{{ file.name }}</div>
      </template>



      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "lamsRegLegalConsultSummaryDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'consultTarget', label: '咨询对象', width: '120px'},
        {key: 'consultTargetOpinion', label: '审核意见', width: '120px'},
        {key: 'attachList', label: '回复附件', width: '120px'},
      ],
      items: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>
